import { render, staticRenderFns } from "./ServiceContracts.vue?vue&type=template&id=22de06f3"
import script from "./ServiceContracts.vue?vue&type=script&lang=js"
export * from "./ServiceContracts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports